import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { siteStats } from "@/mocks/site";

const quickKeywords = ["停水传言", "景区收费", "校园食堂", "快递包裹", "后厨卫生"];

export default function Hero() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/events?q=${encodeURIComponent(q)}` : "/events");
  };

  return (
    <section className="relative w-full overflow-hidden bg-primary-950">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20dark%20editorial%20background%20with%20layered%20warm%20amber%20and%20charcoal%20vertical%20stripes%20and%20soft%20grain%20texture%2C%20minimal%20geometric%20composition%2C%20moody%20cinematic%20lighting%2C%20high%20contrast%20negative%20space%20for%20text&width=1800&height=1000&seq=chigua-hero-main-01&orientation=landscape"
        alt="网报吃瓜官方网站头部背景图，抽象暖色纹理"
        title="网报吃瓜 · 官方通报与辟谣时间线"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/95 via-primary-950/80 to-primary-950/40"></div>

      <div className="relative mx-auto w-full max-w-[1200px] px-4 py-16 md:px-8 md:py-24 lg:py-28">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/60 bg-accent-500/20 px-3 py-1 text-xs font-medium text-accent-200">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-radar-line"></i>
            </span>
            持续追踪官方通报与辟谣原文
          </span>

          <h1 className="mt-6 font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl lg:text-[3.4rem]">
            网报吃瓜
            <span className="mt-3 block text-background-200">
              把碎片信息还原成可复盘的时间线
            </span>
          </h1>

          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            这里对接网报吃瓜的官方通报、声明、回应与辟谣，尽量把碎片信息还原成可复盘的时间线。遇到事件先看官方是否发声、声明原文怎么说、辟谣和调查进展到哪一步，减少被二手转述带着跑。
          </p>

          <form onSubmit={handleSubmit} className="mt-8 flex w-full max-w-xl flex-col gap-3 sm:flex-row">
            <div className="relative flex-1">
              <span className="pointer-events-none absolute left-3.5 top-1/2 flex h-4 w-4 -translate-y-1/2 items-center justify-center text-foreground-400">
                <i className="ri-search-line"></i>
              </span>
              <input
                type="search"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索事件、发布主体或关键词"
                aria-label="搜索事件、发布主体或关键词"
                className="h-12 w-full rounded-md border border-background-300 bg-background-50 pl-10 pr-4 text-sm text-foreground-950 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-300/60"
              />
            </div>
            <button
              type="submit"
              className="inline-flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-search-line"></i>
              </span>
              查时间线
            </button>
          </form>

          <div className="mt-4 flex flex-wrap items-center gap-2">
            <span className="text-xs text-background-300">热门搜索：</span>
            {quickKeywords.map((word) => (
              <button
                key={word}
                type="button"
                onClick={() => navigate(`/events?q=${encodeURIComponent(word)}`)}
                className="rounded-full border border-background-50/25 px-3 py-1 text-xs text-background-100 transition-colors hover:border-accent-400 hover:text-accent-200"
              >
                {word}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-4 border-t border-background-50/15 pt-8 lg:grid-cols-4">
          {siteStats.map((stat) => (
            <div key={stat.label}>
              <div className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
                {stat.value}
                <span className="ml-1 text-sm font-normal text-background-300">{stat.unit}</span>
              </div>
              <div className="mt-1 text-xs text-background-300 md:text-sm">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}